import mock from '@core/utils/mock'
import {contains} from 'underscore'

const overrides = ['auth', 'logs', 'mfa']

export default {
    ...mock,
    shouldMock: (type) => contains(overrides, type) ? false : mock.shouldMock
}
